import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { buildExpandedTasksSearch } from "helpers/modelTaskUrlState";

/**
 * Mirrors the open rows into the query string so a refresh lands back where the
 * user was.
 *
 * Replaces rather than pushes: expanding rows is not navigation, and pushing
 * would bury the previous screen under an entry per toggle.
 */
const useExpandedTasksUrlSync = ({ expandedIds, primaryId }) => {
	const location = useLocation();
	const navigate = useNavigate();
	const lastWrittenRef = useRef(null);

	useEffect(() => {
		const search = buildExpandedTasksSearch(location.search, {
			expandedIds: [...expandedIds],
			primaryId,
		});
		if (search === lastWrittenRef.current) return;

		const current = location.search.replace(/^\?/, "");
		if (search === current) {
			lastWrittenRef.current = search;
			return;
		}

		lastWrittenRef.current = search;
		navigate({ search: search ? `?${search}` : "" }, { replace: true });
	}, [expandedIds, location.search, navigate, primaryId]);
};

export default useExpandedTasksUrlSync;
